'use client';

import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import type { QueryClient } from '@tanstack/react-query';
import AuthBootstrap from '@/components/hrm/auth/AuthBootstrap';
import HRMShell from '@/components/hrm/layout/HRMShell';
import SelfOnboardLayout from '@/components/self-onboard/SelfOnboardLayout';
import SelfOnboardLandingPage from '@/components/self-onboard/SelfOnboardLandingPage';
import SelfOnboardDetailsPage from '@/components/self-onboard/SelfOnboardDetailsPage';
import SelfOnboardVerifyOtpPage from '@/components/self-onboard/SelfOnboardVerifyOtpPage';
import SelfOnboardSetPasswordPage from '@/components/self-onboard/SelfOnboardSetPasswordPage';
import SelfOnboardThankYouPage from '@/components/self-onboard/SelfOnboardThankYouPage';
import { isPublicSelfOnboardPath } from '@/lib/public-routing';

type AppRootProps = {
  queryClient: QueryClient;
};

function ProtectedApp() {
  return (
    <AuthBootstrap>
      <HRMShell />
    </AuthBootstrap>
  );
}

export default function AppRoot({ queryClient }: AppRootProps) {
  const location = useLocation();

  if (isPublicSelfOnboardPath(location.pathname)) {
    return (
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route element={<SelfOnboardLayout />}>
            <Route path="/self-onboard/thank-you" element={<SelfOnboardThankYouPage />} />
            <Route path="/self-onboard/:token" element={<SelfOnboardLandingPage />} />
            <Route path="/self-onboard/:token/details" element={<SelfOnboardDetailsPage />} />
            <Route path="/self-onboard/:token/verify-email" element={<SelfOnboardVerifyOtpPage />} />
            <Route path="/self-onboard/:token/set-password" element={<SelfOnboardSetPasswordPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/*" element={<ProtectedApp />} />
      </Routes>
    </QueryClientProvider>
  );
}
